// extracted by mini-css-extract-plugin
export default {"menu":"Reviews_menu__xfBfK","menuItem":"Reviews_menuItem__TaXRc"};